import { createSelector } from "reselect";

const selectPostsReducer = (state) => state.postsReducer;

// Input selector: Fetch post ID
const selectPostId = (_, id) => id;

// Memoized selector: Compute the specific post by ID
export const selectPostById = createSelector(
  [selectPostsReducer, selectPostId],
  (postsReducer, id) => postsReducer?.postById?.[id] || {},
);
